<template>
    <v-container>
        <v-card class="mx-auto">
            <v-toolbar flat color="secondary">
                <v-toolbar-title>{{edit === true ? 'Edit Kategori':'Tambah Kategori'}}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                 <v-form
                    ref="form"
                    v-on:submit.prevent="storeCategory()"
                    lazy-validation>
                    <v-row>
                        <v-col cols="6">
                            
                            <v-text-field
                            v-model="name"
                            :counter="50"
                            label="Nama Kategori"
                            :rules="this.rules.nama_w_number"
                            v-focus
                            outlined
                            ></v-text-field>

                            <v-select
                            v-model="parent"
                            label="Parent"
                            :items="select_parents"
                            :rules="this.rules.not_empty"
                            outlined
                            ></v-select>

                            <v-text-field
                            v-model="level"
                            label="Level"
                            type="number"
                            :rules="this.rules.not_empty"
                            outlined
                            ></v-text-field>

                        </v-col>

                        <v-col cols="6">
                            
                            <v-select
                            v-model="active"
                            label="Active"
                            :items="select_actives"
                            :rules="this.rules.boolean"
                            outlined
                            ></v-select>

                            <v-file-input
                                v-model="files"
                                label="Image"
                                accept="image/jpeg,image/jpg"
                                prepend-icon="mdi-camera"
                                outlined
                            ></v-file-input>

                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-card-actions>
                                <v-btn @click="btnBack"
                                color="grey lighten-5" type="button"><v-icon left>{{icon.back}}</v-icon>Back</v-btn>
                                <v-spacer></v-spacer>
                                <v-btn 
                                :disabled="loading"
                                color="primary" type="submit" class="float-right"><v-icon left>{{icon.save}}</v-icon>Simpan</v-btn>
                            </v-card-actions>
                        </v-col>
                    </v-row>
                 </v-form>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
/* eslint-disable */
    import rules from "@/plugins/validation_rules.js";
    let context;
    export default{
        name:"category.add",
        data:()=>{
            return{
                edit:false,
                loading:false,
                show:false,
                rules:rules,
                icon:{
                    save:"mdi-check-bold",
                    back:"mdi-arrow-left"
                },
                select_parents:[
                    {value:0,text:"No Parent"},
                ],
                select_actives:[
                    {value:1,text:"Active"},
                    {value:0,text:"Disable"},
                ],
                name:"",
                parent:"",
                level:"",
                active:"",
                files:null
            }
        },
        methods:{
            btnBack () {
                this.$router.go(-1);
            },
            async getData(){
                let output=[];
                await context.$http
                .get("category/table")
                .then(response=>{
                    console.log(response)
                    response.data.data.data.forEach((item,index)=>{
                        context.select_parents.push({
                            value:item.id,
                            text:item.name
                        })
                    });
                    
                })
                .catch(err=>{
                    context.$notify({
                            group:"error",
                            title:"Error Notification",
                            text:"Terjadi kesalahan pada client"
                    })
                })
                return output;
            },
            storeCategory:async ()=>{
                if(context.$refs.form.validate()){
                    context.loading=true;
                    let formData=new FormData();
                    formData.append("name",context.name);
                    formData.append("parent_id",context.parent);
                    formData.append("level",context.level);
                    formData.append("active",context.active);
                    formData.append("image",context.files);
                    
                    if(!context.edit){
                        await context.$http
                        .post('category/store',formData)
                        .then(response=>{
                            if(response.status===200){
                                context.$notify({
                                    group:"success",
                                    title:"Success Notification",
                                    text:"Berhasil menambahkan "+context.name+" ke database"
                                })
                                context.getData();
                                context.$refs.form.reset();
                            }
                        })
                        .catch(err=>{
                            context.$notify({
                                    group:"error",
                                    title:"Error Notification",
                                    text:"Terjadi kesalahan pada client"
                            })
                        });
                    }else{
                        formData.append("id",context.$route.params.id);
                        await context.$http
                        .post('category/update',formData)
                        .then(response=>{
                            if(response.status===200){
                                context.$notify({
                                    group:"success",
                                    title:"Success Notification",
                                    text:"Berhasil merubah "+context.name
                                })
                            }
                        })
                        .catch(err=>{
                            context.$notify({
                                    group:"error",
                                    title:"Error Notification",
                                    text:"Terjadi kesalahan pada client"
                            })
                        });
                    }
                    
                    context.loading=false;
                }
            },

        },
        async mounted(){
            context=this;
            context.getData();
            if(context.$route.name==="category.edit"){
                context.edit=true;
                await context.$http
                .get('category/get?id='+context.$route.params.id)
                .then(response=>{
                    let category=response.data.data;
                    if(category!=null){
                        context.name=category.name;
                        context.parent=category.parent_id;
                        context.level=category.level;
                        context.active=category.active;
                    }else{
                        context.btnBack();
                    }
                })
                .catch(err=>{

                })
            }
        }
    }
</script>